<template>
    <div class="page">

        <div class="white_bg" style="height: 46px; line-height: 46px;">
            <header class="pageHeader paddingH16 white_bg">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 11px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 46px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
<!--                            <a class="" href="javascript:;" @click="share()">-->
<!--                                <img class="icon" src="icon/white_circle_share_icon.svg"/>-->
<!--                            </a>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">
            <div class="paddingH16 white_bg" style="padding-top:20px; padding-bottom: 16px;">

                <article class="article">
                    <div class="lineHeight21r16f color333 bold">{{dataItem ? dataItem.title : ''}}</div>
                    <div class="font12r clearfix marginT16">
<!--                        <strong class="orange bold floatL">分类：{{dataItem ? dataItem.category.title : ''}}</strong>-->
                        <span class="grey floatR">{{dataItem ? formatDate(dataItem.createTime) : ''}}</span>
                    </div>
                    <div class="lineF6F6F6 marginT16"></div>

                    <div class="color333 font14r marginT16" style="line-height: 24px;"
                         v-html="dataItem ? dataItem.content : ''"></div>

                    <div class="lineF6F6F6 marginT24"></div>

                    <div class="font12r lineHeight21r12f clearfix marginT16">
                        <strong class="color333 bold floatL">作者：{{dataItem ? dataItem.authorName : ''}}</strong>
                        <span class="grey floatR">
                            <i class="icon greyViewIcon size16 alignTop" style="margin-right: 2px; margin-top: 1px;"></i>
                            {{dataItem ? dataItem.pv : ''}}人浏览
                        </span>
                    </div>

                    <div class="grey font10r marginT4" style="line-height: 21px;">
                        *文章版权归作者所有，允许不得转发到第三方平台
                    </div>

                </article>

            </div>

            <div class="paddingH16 white_bg marginT8" style="padding-top:20px; padding-bottom: 16px;">
                <div class="clearfix">
                    <strong class="font18r bold color333 floatL">精选留言</strong>
                    <button class="button leaveWordButton floatR" @click="$refs.commentEditingDrawer.open()">写留言</button>
                </div>
                <commentList ref="commentList"/>
            </div>

        </div><!-- end .body -->

        <commentEditingDrawer ref="commentEditingDrawer" :submit-api-config="apiConfig.submitComment"
              title="写留言" placeholder="有什么想写得吗，快写下来吧" submitText="发布" :id="dataItem ? dataItem.id : ''"/>

    </div>
</template>

<script>
// part and modules
import shixunPagePart       from '@/components/shixunApp/shixunPagePart';
import commentList          from "./commentList";
import commentEditingDrawer from "@comp/drawer/commentEditingDrawer";

// config
import appConfig from '@/appConfig';

// util
import appHelper    from '@/util/appHelper';
import dataMixedUtils from "@util/dataMixedUtils";

const config = {
    name : 'dynamicDetail',
    title : '动态',
    description : '',
    apiConfig : {
        get : {
            url : 'portal/message/getMessageContent',
            dataColumnMapping : {
                // userName : 'name'
            }
        },
        submitComment : {
            url : 'portal/message/comment',
            method : 'post'
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { commentList, commentEditingDrawer },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            enableDataItem : true,
            autoLoadDataItem : true,
        }
    },
    methods : {
        onLoadDataItem : function () {

            this.title = this.dataItem.title;

            let appName = appConfig.name || '';
            appHelper.setTitle(this.dataItem.title);

            this.setWechatShare();

            this.$refs.commentList.loadComment({
                id : this.dataItem.id
            });
        }
    },
    mounted() {

        if (appConfig.mode === 'demo')
        {
            this.dataItem = {
                id : 1,
                title : '五一放假，幼师必学的放假通知写法技巧，块来一起学习吧',
                coverImg : appHelper.getRandomCoverImage(),
                userHead : appHelper.getRandomCoverImage(),
                content : '<p>午节临近，香喷喷的粽子上市，不过可要提醒小朋友和大朋友们粽子好吃，但不要贪多哦！' +
                    '不吃没熟透的粽子蒸煮粽子时，粽香不断飘来，让人忍不住想趁热吃，但是家长一定要注意粽子要在小火慢后' +
                    '才熟，并不是水烧开了就熟了，不熟的粽子不仅味道不佳且不易消化会对孩子的肠胃产生极大负担。</p>',
                authorName: dataMixedUtils.string.getRandomNickName(),
                pv : dataMixedUtils.number.getRandomInteger(100),
                createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(3600 * 24 * 7 * 1000),
                category : {
                    id : 1,
                    title : '师讯培训'
                }
            };
            this.onLoadDataItem();
        }
    }
}
</script>

<style lang="scss" scoped>
.orange {
    color: #FFA724;
}
.grey {
    color: #8994A9;
}
.lineF6F6F6 {
    height: 1px;
    background: #F6F6F6;
}
.leaveWordButton {
    box-sizing: border-box;
    padding: 0 12px;
    width: auto;
    height: 24px;
    line-height: 24px;
    background: transparent;
    border: solid 1px #FFBC3B;

    color: #FFBC3B;
    font-size: 14px;
}
</style>
